import { useState, useEffect } from 'react';
import { LOCAL_STORAGE_KEYS } from '../constants/api';

interface UseSavedCredentialsReturn {
  savedEmails: string[];
  savedUserIds: string[];
  saveEmail: (email: string) => void;
  saveUserId: (id: string) => void;
}

export const useSavedCredentials = (): UseSavedCredentialsReturn => {
  const [savedEmails, setSavedEmails] = useState<string[]>([]);
  const [savedUserIds, setSavedUserIds] = useState<string[]>([]);

  useEffect(() => {
    // טעינת מיילים ות"ז שמורים מה-localStorage
    const emails = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.SAVED_EMAILS) || '[]');
    const userIds = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.SAVED_USER_IDS) || '[]');
    setSavedEmails(emails);
    setSavedUserIds(userIds);
  }, []);

  const saveEmail = (email: string) => {
    if (email && !savedEmails.includes(email)) {
      const newEmails = [...savedEmails, email];
      localStorage.setItem(LOCAL_STORAGE_KEYS.SAVED_EMAILS, JSON.stringify(newEmails));
      setSavedEmails(newEmails);
    }
  };

  const saveUserId = (id: string) => {
    if (id && !savedUserIds.includes(id)) {
      const newUserIds = [...savedUserIds, id];
      localStorage.setItem(LOCAL_STORAGE_KEYS.SAVED_USER_IDS, JSON.stringify(newUserIds));
      setSavedUserIds(newUserIds);
    }
  };

  return {
    savedEmails,
    savedUserIds,
    saveEmail,
    saveUserId,
  };
};
